<script>
  import {httpClient} from '@/utils/http-client';
  import {onMount} from 'svelte';

  let start = '2025-01-01';
  let end = '2025-06-09';
  let stats = null;
  let loading = false;
  let error = null;

  async function fetchStats() {
    loading = true;
    error = null;
    try {
      const res = await httpClient.get(`/user-stats/imagestats?start=${start}&end=${end}`);
      console.log('Response:', res);
      if (res.status !== 200) throw new Error(`Error: ${res.statusText}`);
      stats = await res.data;
    } catch (err) {
      error = err.message;
      console.error('Failed to fetch stats:', error);
    } finally {
      loading = false;
    }
  }

  function downloadCSV() {
    if (!stats) return;

    // Prepare CSV header
    let csv = 'Date,Type,Thumb Drafts Count,Unique Users\n';

    // Add rows
    stats.dailyStats.forEach(row => {
      const date = new Date(row.date).toLocaleDateString();
      const type = cleanType(row.type);
      csv += `${date},${type},${row.thumb_drafts_count},${row.unique_users_count}\n`;
    });

    // Create Blob and trigger download
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `thumb-drafts_${start}_to_${end}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // Helper: if type is JSON, extract "title" field
  function cleanType(type) {
    try {
      const obj = JSON.parse(type);
      if (obj.title) return obj.title;
      return JSON.stringify(obj);
    } catch {
      return type;
    }
  }

  onMount(fetchStats);
</script>

<h1>Thumb Draft Stats</h1>

<div>
  <label
    >Start Date:
    <input type="date" bind:value={start} />
  </label>
  <label
    >End Date:
    <input type="date" bind:value={end} />
  </label>
  <button on:click={fetchStats}>Fetch</button>
</div>

{#if loading}
  <p>Loading...</p>
{:else if error}
  <p style="color:red;">{error}</p>
{:else if stats}
  <div class="count-box">
    <h2>Count per Type</h2>
    <ul>
      {#each stats.count as c}
        <li><strong>{cleanType(c.type)}</strong>: {c.count}</li>
      {/each}
    </ul>
  </div>

  <div class="count-box">
    <h2>Total Unique Users: {stats.userCount}</h2>
  </div>

  <div style="margin-bottom: 1rem;">
    <button on:click={downloadCSV}>📥 Download CSV</button>
  </div>

  <h2>Daily Stats</h2>
  <table>
    <thead>
      <tr>
        <th>Date</th>
        <th>Type</th>
        <th>Thumb Drafts Count</th>
        <th>Unique Users</th>
      </tr>
    </thead>
    <tbody>
      {#each stats.dailyStats as row}
        <tr>
          <td>{new Date(row.date).toLocaleDateString()}</td>
          <td>{cleanType(row.type)}</td>
          <td>{row.thumb_drafts_count}</td>
          <td>{row.unique_users_count}</td>
        </tr>
      {/each}
    </tbody>
  </table>
{/if}

<style>
  table {
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 1rem;
  }
  th,
  td {
    padding: 0.5rem;
    border: 1px solid #ddd;
    text-align: left;
  }
  th {
    background: #f4f4f4;
  }
  .count-box {
    background: #f8f9fa;
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 6px;
    border: 1px solid #ddd;
  }
</style>
